<template>
  <div class="forgot-password-page">
    <Header />
    <div class="forgot-password-form">
      <Card>
        <div class="mb-3 text-center">
          <h2 class="font-size-20 font-weight-700 text-title-color">Forgot your login details?</h2>
        </div>
        <VForm v-model="formValid" @submit.prevent>
          <VRow>
            <VCol cols="12">
              <VTextField
                label="Application No"
                prepend-inner-icon="mdi-account-box-outline"
                variant="outlined"
                color="primary"
                name="applicationNumber"
                :rules="formRules.applicationNumber"
                v-model="form.applicationNumber"
                placeholder="Enter Application No"
                :disabled="isLoading"
                type="text"
              />
            </VCol>
            <VCol cols="12">
              <VBtn :loading="isLoading" type="submit" color="primary" block flat @click="handleSubmit()"
                >Send login details</VBtn
              >
            </VCol>
            <VCol cols="12">
              <div v-if="isAppicationNotFound" class="info-container info-container__red">
                <p class="font-weight-600">We could not find an account with that email address. Please try again.</p>
              </div>
            </VCol>
            <VCol cols="12">
              <div class="font-size-14">
                <p><i>If we have your email on file, we will send your login details to the email you provided.</i></p>
              </div>
            </VCol>
          </VRow>
        </VForm>
      </Card>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex';
// Service
import userService from '@/services/user-service/user.service';
// Components
import Card from '@/components/common/Card/Card.vue';
import Header from '@/components/common/Header/Header.vue';
//Text
import { errorForgotPasswordText } from '@/text/snackbarsText';
export default {
  name: 'ForgotPasswordForm',
  components: {
    Header,
    Card
  },
  data() {
    return {
      visiblePassword: false,
      formRules: {
        applicationNumber: [(v) => !!v || 'Applicatio Number required']
      },
      form: {
        applicationNumber: ''
      },
      isLoading: false,
      formValid: false,
      isAppicationNotFound: false
    };
  },
  methods: {
    ...mapActions('main', ['showSnackbar']),
    ...mapActions('user', ['logInUser']),
    async handleSubmit() {
      this.isAppicationNotFound = false;
      if (this.formValid === true) {
        this.isLoading = true;
        try {
          await userService.forgotUserPassword(this.form);
          this.$router.push({ name: 'Login' });
          this.resetForm();
        } catch (err) {
          console.error(err);
          this.isAppicationNotFound = true;
          this.showSnackbar({ text: errorForgotPasswordText, color: 'red' });
        } finally {
          this.isLoading = false;
        }
      }
    },
    resetForm() {
      this.form = {
        applicationNumber: ''
      };
    }
  }
};
</script>
